import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from '@/components/layout/app-shell';
import { ActivityPage } from '@/features/activity/activity-page';
import { DashboardPage } from '@/features/dashboard/dashboard-page';
import { EmployeesPage } from '@/features/employees/employees-page';
import { LiveMapPage } from '@/features/live/live-map-page';
import { SettingsPage } from '@/features/settings/settings-page';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <LiveMapPage /> },
      { path: 'activity', element: <ActivityPage /> },
      { path: 'employees', element: <EmployeesPage /> },
      { path: 'health', element: <DashboardPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
]);
